import React from 'react';
import { Helmet } from 'react-helmet';
import './donate.css';

function Donate() {
  return (
    <>
      <Helmet>
        <title>Ủng Hộ GiveLive - Cùng Phát Triển Nền Tảng Give Away Miễn Phí</title>
        <meta name="description" content="Ủng hộ GiveLive để duy trì và phát triển nền tảng Give Away miễn phí cho cộng đồng Streamer Việt Nam" />
      </Helmet>

      <div className="donate-container">
        <section className="donate-hero">
          <h1>Ủng Hộ GiveLive</h1>
          <p className="donate-subtitle">
            Cùng chúng tôi phát triển nền tảng Give Away miễn phí cho cộng đồng Streamer Việt Nam
          </p>
        </section>

        <section className="donate-content">
          <div className="donate-story">
            <h2>Câu Chuyện Của Chúng Tôi</h2>
            <p>
              GiveLive được tạo ra với mục tiêu hỗ trợ cộng đồng Streamer Việt Nam tổ chức các
              chương trình Give Away một cách chuyên nghiệp và hoàn toàn miễn phí. Để duy trì và
              phát triển nền tảng, chúng tôi rất cần sự ủng hộ từ cộng đồng.
            </p>
          </div>

          <div className="donate-methods">
            <h2>Phương Thức Ủng Hộ</h2>
            <div className="qr-container">
              <div className="qr-card">
                <i className="fas fa-qrcode"></i>
                <h3>Quét Mã QR</h3>
                <div className="qr-image">
                  <img src={require("../../assets/images/donate-qr.png")} alt="Mã QR Ủng hộ" />
                </div>
                <p className="qr-guide">
                  Quét mã QR bằng ứng dụng ngân hàng hoặc ví điện tử để ủng hộ
                </p>
                <p className="account-info">
                  THÔNG TIN CHUYỂN KHOẢN<br />
                  10168324600571525<br />
                  SEKAIZ DONATION<br />
                  TMCP Kiên Long (Kienlongbank)<br />
                  Chi nhánh TP.Hồ Chí Minh
                </p>
              </div>
            </div>
          </div>

          <div className="donate-benefits">
            <div className="benefits-grid">
              <div className="benefit-item">
                <i className="fas fa-server"></i>
                <h3>Duy Trì Máy Chủ</h3>
                <p>Đảm bảo hệ thống hoạt động ổn định 24/7</p>
              </div>

              <div className="benefit-item">
                <i className="fas fa-code"></i>
                <h3>Phát Triển Tính Năng</h3>
                <p>Thêm các tính năng mới theo yêu cầu cộng đồng</p>
              </div>

              <div className="benefit-item">
                <i className="fas fa-shield-alt"></i>
                <h3>Bảo Mật & Tối Ưu</h3>
                <p>Nâng cao bảo mật và hiệu suất hệ thống</p>
              </div>
            </div>
          </div>

          <div className="donate-thanks">
            <h2>Lời Cảm Ơn</h2>
            <p>
              Chúng tôi xin chân thành cảm ơn sự ủng hộ của cộng đồng. Mỗi đóng góp, dù lớn hay nhỏ,
              đều là động lực để chúng tôi tiếp tục phát triển GiveLive ngày càng tốt hơn.
            </p>
          </div>
        </section>
      </div>
    </>
  );
}

export default Donate; 